import React from "react";

function PaymentGateway() {
    const buttonStyle = {
        backgroundColor: '#FF001E',
        color: 'white',
        padding: '10px 20px',
        border: 'none',
        borderRadius: '5px',
        cursor: 'pointer',
        fontSize: '16px',
        transition: 'background-color 0.3s ease',
    };

    const loadRazorpay = () => {
        const script = document.createElement("script");
        script.src = "https://checkout.razorpay.com/v1/checkout.js";
        script.async = true;
        document.body.appendChild(script);
    };

    const handlePayment = () => {
        const options = {
            key: "rzp_live_8kDt87HHS3duBY", // Replace with your key_id
            subscription_id: "sub_PZiFndUSDhrSGg", // Replace with your subscription_id
            name: "TITA TECHNOLOGIES",
            description: "Monthly Subscription",
            handler: function (response) {
                alert("Payment successful. Subscription ID: " + response.razorpay_subscription_id);
            },
        
            notes: {
                address: "Corporate Office",
            },
            theme: {
                color: "#0A0909",
            },
        };

        const rzp1 = new window.Razorpay(options);
        rzp1.open();
    };

    React.useEffect(() => {
        loadRazorpay();
    }, []);

    return (
        <div>
            <button
                style={buttonStyle}
                onMouseOver={(e) => (e.target.style.backgroundColor = '#e6001a')}
                onMouseOut={(e) => (e.target.style.backgroundColor = '#FF001E')}
                onClick={handlePayment}
            >
                RAZOR PAY SUBSCRIBE
            </button>
        </div>
    );
}

export default PaymentGateway;